import { useEffect, useRef } from 'react';
import { isEmpty, has } from 'lodash-es';
import { today } from '../utils/date';
import { WebStorage } from './useWebStorage';

const localStoragePublishedKey = 'home_page_last_forecast_published_at';
const localStorageSeenKey = 'home_page_last_forecast_seen_at';

export const useForecastSeenAt = (currentForecast = {}, forecasts) => {
  const { current: webStorage } = useRef(new WebStorage(window.localStorage));
  const lastForecastPublishedAt = webStorage.getItem(localStoragePublishedKey);
  let lastForecastSeenAt = webStorage.getItem(localStorageSeenKey) || {};

  if (!isEmpty(forecasts) && lastForecastPublishedAt) {
    forecasts.forEach((forecast) => {
      const refNo = `${forecast.company_id}:${forecast.kpi_metric_name}`;
      if (!has(lastForecastSeenAt, refNo)) {
        lastForecastSeenAt = { ...lastForecastSeenAt, [refNo]: lastForecastPublishedAt };
      }
    });
  }
  const forecastRefNo = !isEmpty(currentForecast) ? `${currentForecast.company_id}:${currentForecast.kpi_metric_name}` : null;

  if (forecastRefNo && !lastForecastSeenAt[forecastRefNo] && lastForecastPublishedAt) {
    lastForecastSeenAt[forecastRefNo] = lastForecastPublishedAt;
  }

  useEffect(() => {
    if (forecastRefNo) {
      webStorage.setItem(
        localStorageSeenKey,
        { ...lastForecastSeenAt, [forecastRefNo]: today() },
      );
    }
  }, [forecastRefNo]);

  return lastForecastSeenAt;
};
